/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

// eslint-disable-next-line @typescript-eslint/ban-types
declare const gtag: Function;

@Component({
  selector: 'app-installation-prompt',
  templateUrl: './installation-prompt.component.html',
  styleUrls: ['./installation-prompt.component.scss']
})
export class InstallationPromptComponent implements OnInit, OnDestroy {
  public beforeInstallPrompt: any = null;
  public showInstallPrompt = false;
  public instalationRejected = true;
  public labels = {
    title: marker('installationPrompt.title'),
    subtitle: marker('installationPrompt.subtitle'),
    cancel: marker('common.cancel'),
    install: marker('installationPrompt.install')
  };
  private timeout: NodeJS.Timeout = null;
  private readonly INSTALATION_REJECTED = 'pwa_instalation_rejected_timestamp';
  // Cada 9 horas se volverá a mostrar si fue rechazada la instalación
  private readonly INSTALATION_REJECTED_TIME_EXPIRATION = 9 * 60 * 60 * 1000;

  constructor() {}

  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e: any) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    this.showInstallPrompt = true;
    // Stash the event so it can be triggered later.
    this.beforeInstallPrompt = e;
  }

  ngOnInit(): void {
    this.checkInstallationRejected();
  }

  ngOnDestroy(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  public install(): void {
    if (this.beforeInstallPrompt) {
      this.beforeInstallPrompt.prompt();
      this.showInstallPrompt = false;
      this.beforeInstallPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');

          // Send analytics event for app installation
          gtag('event', 'app_installed');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.beforeInstallPrompt = null;
      });
    }
  }

  public dismiss(): void {
    this.instalationRejected = true;
    localStorage.setItem(this.INSTALATION_REJECTED, `${+new Date()}`);
    this.checkInstallationRejected();
  }

  private checkInstallationRejected(): void {
    const time = localStorage.getItem(this.INSTALATION_REJECTED);
    if (time) {
      if (+new Date() - parseInt(time, 10) < this.INSTALATION_REJECTED_TIME_EXPIRATION) {
        this.instalationRejected = true;
        if (!this.timeout) {
          this.timeout = setTimeout(() => {
            localStorage.removeItem(this.INSTALATION_REJECTED);
            clearTimeout(this.timeout);
            this.timeout = null;
            this.checkInstallationRejected();
          }, this.INSTALATION_REJECTED_TIME_EXPIRATION + 100);
        }
      } else {
        this.instalationRejected = false;
        localStorage.removeItem(this.INSTALATION_REJECTED);
      }
    } else {
      this.instalationRejected = false;
    }
  }
}
